/**
 * The flag in `enabledFeatureFlags` with which a portal reads and writes its organisation (portal groups, roles and group
 * members) at the leerplatform instead of learning-academy and AcademyDepartments (#6933, ADR 0013).
 */
export const ORGANISATION_IN_LEERPLATFORM = 'organisationInLeerplatform';

/**
 * The base url of the organisation routes of learning-academy (`portalGroup`, `portalGroupTree`, `portalRole`,
 * `portalGroupMembers` and the rename `PUT portalGroup/department/{id}`): the leerplatform API once the portal has
 * switched its organisation over, the academy until then. The paths and bodies are the same on both.
 */
export const organisationApiUrl = (settings) =>
    settings.enabledFeatureFlags?.[ORGANISATION_IN_LEERPLATFORM]
        ? settings.apiUrl
        : settings.portalApiUrl;

/**
 * The full url of the department tree read of the afdelingen-schermen (`sdb-portalgroup`,
 * `aca-portalgroup-subdept`), the successor of AcademyDepartments
 * `GET api/1.0/department/portalGroupTree/{portal}`: the leerplatform once the portal has switched its
 * organisation over, AcademyDepartments until then — there the portal is part of the route. Undefined
 * while the base url or the portal identifier is missing, so the screen does not request before the
 * settings are in.
 */
export const departmentTreeApiUrl = (settings) =>
    settings.enabledFeatureFlags?.[ORGANISATION_IN_LEERPLATFORM]
        ? settings.apiUrl && `${settings.apiUrl}/api/1.0/department/portalGroupTree`
        : settings.academyDepartmentsUrl &&
          settings.portalIdentifier &&
          `${settings.academyDepartmentsUrl}/api/1.0/department/portalGroupTree/${settings.portalIdentifier}`;

/**
 * The base url of the department writes of AcademyDepartments (`department/{portal}`, `AddGroupMember/{portal}` and
 * `RemoveGroupMember/{portal}`): the leerplatform API once the portal has switched its organisation over,
 * AcademyDepartments until then. The paths and bodies are the same on both; the tree read follows the
 * same flag (`departmentTreeApiUrl`), its other reads stay at AcademyDepartments.
 */
export const departmentsWriteApiUrl = (settings) =>
    settings.enabledFeatureFlags?.[ORGANISATION_IN_LEERPLATFORM]
        ? settings.apiUrl
        : settings.academyDepartmentsUrl;

/**
 * The base url of the departments and roles read of `createDepartmentsApi` (`fetchDepartmentsAndRoles`): the leerplatform
 * API once the portal has switched its organisation over, undefined until then, when it reads AcademyDepartments
 * `GET api/326/departmentsAndRoles/{portal}`. That route answers from the RavenDB copy, which a portal without a
 * department does not have yet and whose portal roles the leerplatform does not keep; the leerplatform reads the
 * organisation itself.
 */
export const departmentsAndRolesApiUrl = (settings) =>
    settings.enabledFeatureFlags?.[ORGANISATION_IN_LEERPLATFORM] ? settings.apiUrl : undefined;
